<template>
  <div>
    <p class="text-danger" v-if="employeeState=='showing' && edited">
      Los cambios no han sido guardados.
      <a href="#" @click.prevent="saveChanges">Guardar.</a>
    </p>
    <b-table
      :fields="fixedBonusField"
      :items="fixedBonus"
      :stacked="'md'"
      hover
      striped
    ></b-table>

    <div v-if="state=='creating'">
      <b-form-group horizontal label="Cantidad">
        <b-form-input type="number" @input="updateFixedBonus(['amount', $event])" :value="amount"></b-form-input>
        <b-form-text>*Campo obligatorio, mayor a 0.</b-form-text>
      </b-form-group>
      <b-form-group horizontal label="A partir del">
        <b-form-input
          type="date"
          @input="updateFixedBonus(['effective_date', $event])"
          :value="effective_date"
        ></b-form-input>
        <b-form-text>*Campo obligatorio.</b-form-text>
      </b-form-group>
      <b-form-group horizontal label="Nota">
        <b-form-input
          type="text"
          @input="updateFixedBonus(['note', $event])"
          :value="note"
          :state="noteState"
        ></b-form-input>
        <b-form-text>Máximo 1000 caracteres, {{ note.length }} ingresados.</b-form-text>
      </b-form-group>

      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>

<script>
import { moneyString } from "../../utils";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { Validation } from "../../utils";

export default {
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      fixedBonusField: [
        {
          key: 'amount',
          label: 'Cantidad'
        },
        {
          key: 'effective_date',
          label: 'A partir del'
        },
        {
          key: 'note',
          label: 'Nota'
        },
        {
          key: 'actions',
          label: ' '
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      edited: 'fixedBonusEdited'
    }),
    ...mapState({
      employeeState: state => state.employeeManager.state,
      state: state => state.employeeManager.fixedBonusState,
      amount: state => state.employeeManager.newFixedBonus.amount,
      effective_date: state => state.employeeManager.newFixedBonus.effective_date,
      note: state => state.employeeManager.newFixedBonus.note,
    }),
    fixedBonus() {
      return this.payrollConfig.fixedBonus.map(fb => {
        return {
          amount: fb.amount.split(" ")[0].replace(/\,/g, ""),
          currency: fb.amount.split(" ")[1],
          effective_date: fb.effective_date,
          note: fb.note
        }
      });
    },
    noteState() {
      return this.note.length < 1000;
    },
  },
  methods: {
    ...mapMutations({
      updateFixedBonus: 'updateNewFixedBonusAttribute'
    }),
    ...mapActions(['saveChanges']),
    addIfValid() {
      var validation = this.valid();
      validation.valid ? this.$store.dispatch("addFixedBonus") : this.$store.dispatch("displayError", validation.messageBag);
    },
    valid() {
      var validator = new Validation();
      
      validator.rule(this.amount >= 0, "El bono debe ser mayor a 0");
      validator.rule(
        this.effective_date != "",
        "Debe haber una fecha a partir de la cual el empleado tiene el bono"
      );

      return validator.validate();
    }
  }
}
</script>
